<div class="mb-5">
  <div class="container">
    <div class="row mt-3">
      <div class="col-12">
        <div class="card-space d-flex justify-content-center">
          <div class="card card-bg card-big">
            <div class="card-body">
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <p
                    #main_focus_element
                    id="main_focus_element"
                    class="login-subtitle"
                  >
                    {{ "LANDING_GUEST_DESCR" | translate }}
                  </p>
                </div>
              </div>
              <div class="row mt-2 d-flex justify-content-center">
                <div id="spid-button">
                  <a
                    href="javascript:void(0)"
                    class="italia-it-button italia-it-button-size-m button-spid snipcss-ixP5K"
                    spid-idp-button="#spid-idp-button-medium-get"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="italia-it-button-icon">
                      <img
                        src="assets/spid-ico-circle-bb.svg"
                        onerror="this.src='assets/spid-ico-circle-bb.png'; this.onerror=null;"
                        alt="spid-ico-circle"
                      />
                    </span>
                    <span class="italia-it-button-text"> Entra con SPID </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
